<template>
    <v-container>
 
        <v-row class="contentRow" >
            <v-col cols="11">
                <h1 >
                    {{ $store.getters["user/getUser"].clientName }}'s Self-Assessment
                    Score {{this.year }}
                </h1>
                <v-col align = "end">
                    <v-btn
                        v-if="showFillOutButton"
                        class="yourscorebtn1"
                        style=" color: white; background-color: orange; "
                        elevation="0"
                        exact
                        @click="goToSuppliers"
                        >{{ buttonText }}</v-btn
                    >
                </v-col>
            </v-col>
            <p style="margin-left: 30px; margin-right: 20px;">
                The Orixe Sustainability survey is a comprehensive self-assessment tool that helps organizations measure their maturity in relation to the UN Global Compact's 10 principles. Through a questionnaire-based survey, you can evaluate your sustainability maturity across four key categories: Human Rights, Labour, Environment, and Anti-Corruption. This process provides an overall score for your organization and supply chain while encouraging continuous improvement through honest self-reflection on your status.
            </p>    
            <v-col cols="6" lg="6" md="11" sm="11" class="riskscoredashboard2 rd" style="margin-left: 20px;">
                <v-row class="riskscoreyourname1">
                    <v-col cols="10" class="avg" style="margin-top: 20px;">
                        <supplier-csr
                            :score1="score1"
                            :score2="score2"
                            :score3="score3"
                            :score4="score4"
                            :title="`Your Sustainability Score`"
                        />
                    </v-col>
                </v-row>
 
                <v-col class="darkColor--text1" style="margin-top: 30px;">
                    <h3 style="margin-top: -100px; margin-left: 350px;">
                        Filled out : {{ this.filledoutdate }}
                    </h3>
                </v-col>
            </v-col>
            <v-col cols="5" lg="5" md="10" sm="10" class="riskscoredashboard2" style="margin-left: 40px;">
                <v-col align="center" cols="12">
                    <h2>Download your Sustainability badge</h2>
                </v-col>
                <v-col align="center" cols = "12">
                    <v-img
                        :style="buttonStyle"
                        height="auto"
                        :src="require('../assets/Badge_Sustainability_2025.jpg')"
                    />
                </v-col>
                <v-col align="center" cols="12">
                    <v-btn
                        width="50%"
                        class="mx-auto"
                        color="rgb(30, 154, 116)"
                        style="color: white;"
                        @click="downloadCanvas"
                    >
                        <v-icon left>fas fa-download</v-icon>Download
                    </v-btn>
                </v-col>
            </v-col>
            <v-col align = center>
                <v-btn width="60%" class="mx-auto" color="primary" to="/csr/request">
                    <v-icon left>fas fa-user-plus</v-icon>Invite suppliers to fill out
                    Sustainability form
                </v-btn>
            </v-col>
 
                <v-card
                    style="overflow: hidden; position: relative;"
                    class="elevation-0"
                >
                    <canvas
                        width="600"
                        height="600"
                        style="opacity: 0%; position: absolute;"
                        class="ma-0 justify-center"
                        ref="canvas"
                    />
                </v-card>
            
        </v-row>
        <br/>
        <br/>
        <br/>
		<div v-if="answers ==null">
			<div v-for="(question, index) in csrData" :key="index">
            <div v-if="index==0">
                <v-row
                    class="contentRow primary"
                    :style="
                        question.color
                            ? `background-color: ${question.color} !important; border-color: ${question.color} !important`
                            : ''
                    "
                >
                    <v-col cols="10" class="mr-auto white--text">
                        <h2>This is the Orixe Sustainability Self-Assessment for {{ year }}.</h2>
                    </v-col>
                </v-row>
            </div>
            <div v-if="index!=0">
                <v-row
                    class="my-13"
                    v-if="shouldDisplay(question) && question.type == 'spacer'"
                ></v-row>
                <v-row
                    v-else-if="shouldDisplay(question) && question.type == 'title'"
                    class="contentRow primary"
                    :style="
                        question.color
                            ? `background-color: ${question.color} !important; border-color: ${question.color} !important`
                            : ''
                    "
                >
                    <v-col cols="6" class="mr-auto white--text">
                        <h2>{{ question.name }}</h2>
                    </v-col>
                </v-row>
                <v-row
                    no-gutters
                    v-else-if="shouldDisplay(question) && question.type == 'attachment'"
                    class="contentRow secondary"
                    dark
                >
                    <v-col cols="6" class="mr-auto white--text">
                        <h2>
                            <v-icon dark left>fas fa-paperclip</v-icon>{{ question.name }}
                        </h2>
                    </v-col>
                    <!--'File uplad' text field-->
                    <v-col cols="12" class="white--text">
                        <file-uploader
                            :value="question.fileID"
                            align="center"
                            justify="center"
                            :readonly="true"
                            :disabled="true"
                            :dark="true"
                            :name="question.name"
                        />
                    </v-col>
                </v-row>
                <v-row class="contentRow" v-else-if="shouldDisplay(question)">
                    <v-col>
                        <h4 class="primary--text">
                            {{ question.name
                            }}<sup
                                ><v-icon v-if="question.Required" color="error" right x-small
                                    >fa-asterisk</v-icon
                                ></sup
                            >
                        </h4>
                        <br />
                        <p v-if="!question.answer">
                            <i>This question was not answered</i>
                        </p>
                        <p v-else-if="question.type == 'file'">
                            <file-uploader
                                :value="question.answer"
                                :readonly="true"
                                :disabled="true"
                                :dark="true"
                                :name="question.name"
                            />
                        </p>
                        <p v-else>{{ question.answer }}</p>
                    </v-col>
                </v-row>
            </div>
 
        </div>
		</div>
		<div v-else>			<div v-for="(question, index) in csrData1" :key="index">
			<div v-if="index==0">
				<v-row
					class="contentRow primary"
					:style="
						question.color
							? `background-color: ${question.color} !important; border-color: ${question.color} !important`
							: ''
					"
				>
					<v-col cols="10" class="mr-auto white--text">
						<h2>This is the Orixe Sustainability Self-Assessment for {{ year }}.</h2>
					</v-col>
				</v-row>
			</div>
			<div v-if="index!=0">
				<v-row
					class="my-13"
					v-if="shouldDisplay(question) && question.type == 'spacer'"
				></v-row>
				<v-row
					v-else-if="shouldDisplay(question) && question.type == 'title'"
					class="contentRow primary"
					:style="
						question.color
							? `background-color: ${question.color} !important; border-color: ${question.color} !important`
							: ''
					"
				>
					<v-col cols="6" class="mr-auto white--text">
						<h2>{{ question.name }}</h2>
					</v-col>
				</v-row>
				<v-row
					no-gutters
					v-else-if="shouldDisplay(question) && question.type == 'attachment'"
					class="contentRow secondary"
					dark
				>
					<v-col cols="6" class="mr-auto white--text">
						<h2>
							<v-icon dark left>fas fa-paperclip</v-icon>{{ question.name }}
						</h2>
					</v-col>
					<!--'File uplad' text field-->
					<v-col cols="12" class="white--text">
						<file-uploader
							:value="question.fileID"
							align="center"
							justify="center"
							:readonly="true"
							:disabled="true"
							:dark="true"
							:name="question.name"
						/>
					</v-col>
				</v-row>
				<v-row class="contentRow" v-else-if="shouldDisplay(question)">
					<v-col>
						<h4 class="primary--text">
							{{ question.name
							}}<sup
								><v-icon v-if="question.Required" color="error" right x-small
									>fa-asterisk</v-icon
								></sup
							>
						</h4>
						<br />
						<p v-if="!question.possibilities[0]">
							<i>This question was not answered</i>
						</p>
						<p v-else-if="question.type == 'file'">
							<file-uploader
								:value="question.possibilities[0]"
								:readonly="true"
								:disabled="true"
								:dark="true"
								:name="question.name"
							/>
						</p>
						<p v-else>{{ question.possibilities[answers[index]] }}</p>
					</v-col>
				</v-row>
			</div></div></div>

    </v-container>
</template>
 
<script>
import LoadingState from "../consts/LoadingState"
import CsrAPI from "../api/csr/csr"
import domtoimage from "dom-to-image"
export default {
	name: "CSR-Submission-View",
	data() {
		return {
			id: null,
			csr: null,
			csrData: null,
			csrData1: null,
			answers: [],
			score1: null,
			score2: null,
			score3: null,
			score4: null,
			timestamp: null,
			Resubmit: null,
			csrID: null,
			filledoutdate: "",
			windowWidth: window.innerWidth,
			year:0
		}
	},
	computed: {
		buttonStyle() {
			return {
				width: this.windowWidth > 1900 ? "24%" : "30%",
			}
		},
		showFillOutButton() {
			if (this.Resubmit === 1) {
				return true
			}

			if (this.timestamp) {
				const timestampDate = new Date(this.timestamp)
				console.log(new Date(Date.UTC(timestampDate.getFullYear()+1, 0, 1, 0, 0, 0)))
				const newTimestampDate = new Date(Date.UTC(timestampDate.getFullYear()+1, 0, 1, 0, 0, 0))
				const currentDate = new Date()
				if(newTimestampDate>timestampDate && currentDate>newTimestampDate){
					return true
				}else{
					return false
				}
			}

			return false
		},
		buttonText() {
			if (this.Resubmit === 1) {
				return "Fill Out again"
			}

			if (this.timestamp) {
				const currentYear = new Date().getFullYear()
				return `Fill Out for ${currentYear}`
			}

			return "Fill out now" // Default case, though it should be covered by the conditions above.
		},
	},
	mounted() {
		this.id = parseInt(this.$route.params.id)
		console.log(this.id)
		this.loadCsr()
		window.addEventListener("resize", this.handleResize)
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.handleResize)
	},
	methods: {
		handleResize() {
			this.windowWidth = window.innerWidth
		},
		loadCsr() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			CsrAPI.getCSRAssessment(this.id)
				.then((result) => {
					this.csr = result[0]
					if(result[0].answers != ""){
						this.csrData = JSON.parse(result[0].answers)
					}
					this.csrData1 = result[0].csr.questions.map((question) => ({
						...question,
						visible: question.visible !== undefined ? question.visible : true,
						type: question.type || "spacer",
					}))
					this.answers = JSON.parse(result[0].AnswerNumbers)
					this.score1 = Math.round(result[0].score1) || null
					this.score2 = Math.round(result[0].score2) || null
					this.score3 = Math.round(result[0].score3) || null
					this.score4 = Math.round(result[0].score4) || null
					this.timestamp = result[0].timestamp || null
					this.Resubmit = result[0].Resubmit || null
					this.csrID = result[0].id || null
					if (result[0].timestamp) {
						const date = new Date(result[0].timestamp)
						const month = date.toLocaleString("default", { month: "short" })
						this.year = date.getFullYear()
						this.filledoutdate = `${month} ${this.year}`
					}
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch((reason) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		shouldDisplay(question) {
			if (question.type == "spacer") {
				return true
			}
			if (question.visible == true) {
				return true
			}
			return false
		},
		goToSuppliers() {
			this.$router.push({
				path: "/csr/resubmissions",
				query: { csrID: this.csrID, Resubmit: 1 },
			})
		},
		downloadCanvas() {
			var canvas = this.$refs.canvas
			var context = canvas.getContext("2d")
			var imageObj = new Image()
			let clientName = this.$store.getters["user/getUser"].clientName
			imageObj.onload = () => {
				context.drawImage(imageObj, 0, 0, 600, 600)
				context.font = "25pt Sarabun"
				context.fillStyle = "white"
				context.fillText(clientName, 300, 300, 375)
				this.downloadPng()
			}
			imageObj.src = require("../assets/Badge_Sustainability_2025.jpg")
		},
		downloadPng() {
			console.log(this.$refs.canvas)
			//this.$refs.score.classList.remove("d-none")const scale = 3
			const node = this.$refs.canvas
			let clientName = this.$store.getters["user/getUser"].clientName
			let contentHeight = 600
			let contentWidth = 600
			let newWidth = 600
			let newHeight = 600
			var scale = Math.min(
				node.offsetWidth / contentWidth,
				node.offsetHeight / contentHeight
			)
			const style = {
				transform: "scale(" + scale + ")",
				transformOrigin: "top left",
				width: newWidth + "px",
				height: newHeight + "px",
				opacity: "100%",
				position: "relative",
			}

			const param = {
				height: node.offsetHeight * scale,
				width: node.offsetWidth * scale,
				style,
			}
			domtoimage.toPng(this.$refs.canvas, param).then(function(dataUrl) {
				var link = document.createElement("a")
				link.download =
					"orixe-esg-" +
					clientName.replace(/[^a-z0-9]/gi, "_").toLowerCase() +
					".png"
				link.href = dataUrl
				link.click()
			})
			//this.$refs.score.classList.add("d-none")
		},
	},
}
</script>
<style>
.riskscoreyourname1 {
    padding: 0px;
    padding-left: 0px;
    margin-left: -160px;
    margin-top: -90px;
    transform: scale(0.6);
    width: max-content;
}
.yourscorebtn1{
    position: relative;
    top: -50px;
    left: 100px;
}
.riskscoreyourname1 .supplier-csr-wrapper {
    flex-wrap: inherit !important;
    margin-left: -200px;
    width: calc(100% + 448px);
}
 
.riskscoreyourname1 .supplier-csr-wrapper .flex-grow-0 {
    margin-right: 10px !important;
}
 
.riskscoreyourname1 .supplier-csr-header {
    justify-content: left !important;
}
.riskscoredashboard2 {
    height: 290px;
    margin: 10px;
    border: 1px solid #ddd;
    padding: 0px;
    border-radius: 10px;
}
@media (min-width: 1900px){
    .riskscoredashboard2 {
        height: 290px;
        margin: 10px;
        border: 1px solid #ddd;
        padding-left: 80px;
        border-radius: 10px;
        
    }
    .riskscoreyourname1 {
        padding: 0px;
        padding-left: 0px;
        margin-left: -80px;
        margin-top: -90px;
        transform: scale(0.6);
        width: max-content;
        justify-content: center;
    }
}
@media (max-width: 1263px){
    .riskscoredashboard2 {
        height: 350px;
        margin: 10px;
        border: 1px solid #ddd;
        padding-left: 5%;
        border-radius: 10px;
        
    }
    .yourscorebtn1{
        position: relative;
        top: 10px;
        left: 100px;
    }
    .riskscoreyourname1 {
        padding: 0px;
        padding-right: -200px;
        margin-top: -65px;
        transform: scale(0.6);
        width: max-content;
        justify-content: center;
    }
}
</style>